import Icon from './Icon'
import { t } from '../lib/i18n'

/**
 * This is not the official ferry booking service, and it says so.
 *
 * ── Why this exists ──────────────────────────────────────────────────────────
 *
 * The app carries real vessel names, a plausible timetable that is SAMPLE DATA,
 * and a payment step that charges nothing. Every one of those is correct for a
 * working prototype and every one of them is dangerous on a public URL: a
 * visitor who believes they have a ticket for the 17:30 does not turn up at the
 * counter, and misses the boat. On an island the next one may be tomorrow.
 *
 * The `EnvBanner` above covers beta and local. This covers PRODUCTION, which is
 * the only environment a stranger can reach, and stays until the two things
 * that make it untrue are done: real sailing data from the operator, and a live
 * payment processor.
 *
 * Flip `IS_PREVIEW` to false when both are true. One line, one place, and the
 * whole notice and the noindex tag go with it.
 */
export const IS_PREVIEW = true

export default function PreviewNotice({ environment }: { environment: string }) {
  if (!IS_PREVIEW || environment !== 'production') return null
  return (
    <div className="preview-notice" role="status">
      <Icon name="info" size={16} />
      <span>
        <strong>{t('preview.title')}</strong> {t('preview.body')}
      </span>
    </div>
  )
}
